import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClosingChecksComponent } from './closing-check-overview.component';
import { CheckListComponent } from './checks/list/check-list.component';
import { MsalGuard } from '@azure/msal-angular';
import { UserResolve } from 'src/app/users/user/user.resolve';
import { UserGuard } from 'src/app/users/user.guard';
import { NeedsReconciliationListComponent } from './reconciliations/list/needs-reconciliation-list.component';
import { ReconciliationNewComponent } from './reconciliations/reconciliation-new.component';
import { ScheduleComponent } from './schedules/schedule.component';
import { ScheduleListComponent } from './schedules/list/schedule-list.component';
import { ClosingCheckAdminComponent } from './admin/closing-check-admin.component';

const routes: Routes = [
    {
        path: 'site-checks',
        canActivate: [MsalGuard],
        data: { breadcrumb: 'Site Checks' },
        children: [
            {
                path: '',
                data: { breadcrumb: 'Overview' },
                component: ClosingChecksComponent,
                pathMatch: 'full',
                canActivate: [MsalGuard, UserGuard],
            },
            {
                path: 'submissions',
                data: { breadcrumb: 'Submissions' },
                component: CheckListComponent,
                pathMatch: 'full',
                canActivate: [MsalGuard, UserGuard],
            },
            {
                path: 'reconciliations',
                data: { breadcrumb: 'Reconciliations' },
                component: NeedsReconciliationListComponent,
                pathMatch: 'full',
                canActivate: [MsalGuard, UserGuard],
            },
            {
                path: 'reconcile',
                data: { breadcrumb: 'Reconcile' },
                component: ReconciliationNewComponent,
                pathMatch: 'full',
                canActivate: [MsalGuard, UserGuard],
            },
            {
                path: 'schedule',
                data: { breadcrumb: 'Schedule' },
                component: ScheduleComponent,
                pathMatch: 'full',
                canActivate: [MsalGuard, UserGuard],
            },
            {
                path: 'schedules',
                data: { breadcrumb: 'Schedules' },
                component: ScheduleListComponent,
                pathMatch: 'full',
                canActivate: [MsalGuard, UserGuard],
            },
            {
                path: 'admin',
                data: { breadcrumb: 'Admin' },
                component: ClosingCheckAdminComponent,
                pathMatch: 'full',
                canActivate: [MsalGuard, UserGuard],
            }
        ]
    },
];

export const routedComponents = [
    ClosingChecksComponent, 
    CheckListComponent, 
    NeedsReconciliationListComponent,
    ReconciliationNewComponent,
    ScheduleComponent,
    ScheduleListComponent,
    ClosingCheckAdminComponent
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [UserResolve],
})
export class ClosingChecksRoutingModule {}
